import React from 'react';
import styled from 'styled-components';
import { pick } from 'lodash';
import StyledSelect from 'components/atoms/inputs/Select';
import ProtectedComponent from 'hoc/ProtectedComponent';
import { ENTITY_OBJECTIVE_EKPI } from 'constants/capabilities';

const StyledSelectRaw = styled(StyledSelect)`
    text-transform: none;
`;

const EKPIProtectedOption = ProtectedComponent({
    requiredCapabilities: [ENTITY_OBJECTIVE_EKPI],
    alwaysRender: false,
    onRenderProps: ({ props, check }) => {
        if (check) {
            // has access
            return props;
        }

        if (props.initialValue === 'ekpi') {
            // no access, but value is set to eKPI
            return {
                ...props,
                disabled: true
            };
        }

        return {
            // no access, hide option all together
            ...props,
            style: {
                display: 'none'
            }
        };
    }
})(props => <option {...pick(props, ['value', 'children'])} className="choose"></option>);

const SelectObjectiveList = (props) => {
    const { input, meta } = props;

    return (
        <StyledSelectRaw {...input}>
            <option value='ecpa' className="choose">
                eCPA
            </option>
            <option value='ctr' className="choose">
                CTR
            </option>
            <EKPIProtectedOption value='ekpi' initialValue={meta.initial}>eKPI</EKPIProtectedOption>
        </StyledSelectRaw>
    );
};

export default SelectObjectiveList;



// WEBPACK FOOTER //
// ./src/components/atoms/inputs/SelectObjectiveList.js